<template>
  <div class="full-height tkRefundDetail linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      退票详情
    </ld-header>
    <div class="tkRefundDetailswrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="content">
          <div class="white m-b-5 pad-8">
            <div class="font22 font-md fontTitle">
              <span>{{ exitDetailData.refundStatusRemark }}</span>
              <ld-email-popup
                v-if="exitDetailData.refundId"
                :id="exitDetailData.refundId"
                :djlx="11002"
                :order-no="exitDetailData.orderNo"
              />
            </div>
            <!--            <van-row>-->
            <!--              <van-col span="24">-->
            <!--                {{ $t('I208','退票原因') }}：{{ exitDetailData.refundResaonVip }}-->
            <!--              </van-col>-->
            <!--            </van-row>-->
            {{ $t('K121','申请时间') }}：{{ exitDetailData.applyDate }}
            <!--            <van-row v-show="exitDetailData.refundResaon">-->
            <!--              <van-col span="24">-->
            <!--                {{ $t('C325','非自愿退票原因') }}：{{ exitDetailData.refundResaon }}-->
            <!--              </van-col>-->
            <!--              &lt;!&ndash; <van-col span="4">-->
            <!--          退票证明  查看附件 非自愿退票-->
            <!--          </van-col> &ndash;&gt;-->
            <!--            </van-row>-->
            <van-row>
              <van-col span="24">
                <span v-show="exitDetailData.refundType === 1">自愿退票：</span>
                <span v-show="exitDetailData.refundType === 2">非自愿退票：</span>
                {{ exitDetailData.refundResaon }}
              </van-col>
            </van-row>
          </div>

          <van-cell class="m-b-5 round-sm">
            <van-row>
              <van-col span="18">
                {{ $t('F012','原订单号') }}：{{ exitDetailData.orderNo }}
              </van-col>
              <van-col
                span="6"
                @click="lookToOldDetail(exitDetailData.orderId)"
                class="text-right main-color"
              >
                {{ $t('C338','查看原订单') }}
              </van-col>
            </van-row>
          </van-cell>
          <!--航段展示-->
          <div
            class="m-b-5"
            v-for="(item,index1) in exitDetailData.refundRangeList"
            :key="index1"
          >
            <voyage
              :flights="[item]"
              :show-rule="true"
            />
          </div>
          <!-- 乘机人 -->
          <van-cell class="m-b-5">
            <template slot="title">
              {{ tkOrderPsgBean.psgName }}
              <van-tag
                type="warning"
                v-show="tkOrderPsgBean.fsEmpId"
              >
                {{ $t('attach','附') }}
              </van-tag>
            </template>
            <template slot="label">
              <div>
                {{ tkOrderPsgBean.idType|cardType }}：
                {{ tkOrderPsgBean.idNo ? tkOrderPsgBean.idNo.replace(/^(.{4})(?:\w+)(.{4})$/,
                                                                     "\$1******\$2") : "" }}
              </div>
              <div>{{ $t('F008','手机号') }}：{{ tkOrderPsgBean.phoneNumber }}</div>
              <div>{{ $t('F005','票号') }}：{{ tkOrderPsgBean.tkno }}</div>
            </template>
          </van-cell>

          <!--   -->
          <!-- <van-cell title="退票进度" />
          <van-steps
            class="ld-step m-b-5 font14"
            direction="vertical"
            :active="refundStatus"
          >
            <van-step> 申请已提交 </van-step>
            <van-step v-show="isShowApproval">
              已送审
            </van-step>
            <van-step> 办理退票中 </van-step>
            <van-step> 退票完成 </van-step>
            <van-step> 退款<span>(款项已退回原支付账户)</span> </van-step>
          </van-steps> -->

          <!-- 审批规则 -->
          <approval
            v-show="vipStatus==1 || vipStatus == 2 || vipStatus == 3"
            :vip-status="exitDetailData.vipStatus"
            :order-id="exitDetailData.refundId"
            :spgz-id="exitDetailData.appId"
            :isssbz="exitDetailData.isShowApproval!='1'"
          />
          <ld-uploader
            class="mt5 round-sm overflow"
            v-if="exitDetailData.refundId"
            :order-id="exitDetailData.refundId"
            :glywlx="'11002'"
            :cjlx="2"
            :order-status="exitDetailData.refundStatus"
          />

          <!--  -->
        </div>
      </mescroll-vue>
    </div>
    <!---->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
      class="bg-white shadow"
    >
      <van-row
        class="full-width "
        type="flex"
        align="center"
        justify="space-between"
        gutter="8"
      >
        <van-col
          span="12"
          class="text-nowrap"
        >
          {{ $t('E005','应退') }}：
          <span class="font12 red">&yen; </span>
          <span class="font16 red"> {{ exitDetailData.cuRefundAmount }}</span>
        </van-col>
        <van-col span="4">
          <div
            class="font12 text-center "
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div>
        </van-col>
        <van-col
          span="8"
          v-if="exitDetailData.isShowCancleRefund==1"
        >
          <ld-button
            defaults
            size="md"
            @click="cancleRefundTicket(exitDetailData.refundId)"
          >
            {{ $t('B008','取消') }}
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="exitDetailData.isShowCancelApproval==1"
        >
          <ld-button
            defaults
            size="md"
            @click.native="revertApproval"
          >
            {{ $t('B065','撤回') }}
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="exitDetailData.isShowApproval==1||exitDetailData.isShowApproval==2"
        >
          <ld-button
            main
            size="md"
            @click="toSend"
          >
            {{ $t('B028','送审') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
import { Cell ,Tag, Step, Steps, Popup} from 'vant'
// import voyage from 'Components/tk/voyage'
import voyage from 'Views/Tk/tkQuery/dc/voyage/index.vue'

import ldTabbar from 'Components/ldTabbar/ldTabbar'
import approval from 'Components/approval/approval'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Bussiness from 'Utils/business'
import ldEmailPopup from 'Components/LdEmailPopup'
import ldUploader from 'Components/ldUploader'


export default {
  provide: {
    orderType: $dict.ORDER_TYPE.tk.normal
  },
  template: 'tkRefundDetails',
  components: {
    ldButton,
    [Cell.name]:Cell,
    [Tag.name]:Tag,
    [Step.name]:Step,
    [Steps.name]:Steps,
    [Popup.name]:Popup,
    voyage,
    ldTabbar,
    approval,
    MescrollVue,
    ldEmailPopup,
    ldUploader
  },
  data() {
    return {
      down:{use:false},
      exitDetailData: {},
      tkOrderPsgBean: {},
      //退票状态
      zhuangTai: '1',
      isShowApproval: 0,
      vipStatus: '',// 当 值为  1 2 3 时，显示审批状态
      spjd: '',
      showRefundChange:false,
    }
  },
  props:{
    id:{
      type:String,
      default:''
    }
  },
  computed:{
    priceList(){
      return [
        { name: '原票价', price: Math.abs(this.exitDetailData.refundSalePrice),show:Math.abs(this.exitDetailData.refundSalePrice)!= 0 },
        { name: '退票价', price: this.exitDetailData.refundSalePrice,show:this.exitDetailData.refundSalePrice!= 0},
        { name: '退机建', price: this.exitDetailData.refundAirportFee,show: this.exitDetailData.refundAirportFee != 0},
        { name: '退税费', price: this.exitDetailData.refundTax,show: this.exitDetailData.refundTax!= 0},
        { name: '退票服务费', price: this.exitDetailData.refundServiceFee,show:this.exitDetailData.refundServiceFee!= 0},
        { name: '加收服务费', price: this.exitDetailData.serviceFee,show:this.exitDetailData.serviceFee!= 0 },
        { name: '退票手续费', price: this.exitDetailData.cuRefundPoundage,show: this.exitDetailData.cuRefundPoundage != 0},
      ]
    },
    orderId(){
      return this.$route.query.orderId||this.id
    },
    refundStatus(){
      if(this.exitDetailData.refundStatus==7){
        return false
      }
      return parseInt(this.exitDetailData.refundStatus)
    }
  },
  created(){
    this.getRefundDetail()
    console.log(this,'0000')
  },
  activated(){
    this.getRefundDetail()
  },
  methods: {

    getRefundDetail: function () {// 获取退票详情
      // var refundId = this.$route.query.refundId;
      // if (!refundId) {
      // 	mui.alert('推送的退票id获取不到,请在审批列表里查看！');
      // 	return false;
      // };
      this.$api['tkOrder/refundOrderDetail']({
        refundId: this.orderId
      }).then((resp) => {
        this.exitDetailData = resp.data
        this.tkOrderPsgBean = resp.data.tkOrderPsgBean
        this.isShowApproval = resp.data['isShowApproval']
        this.zhuangTai = resp.data['refundStatus']
        this.vipStatus = resp.data['vipStatus']   // 判断审批状态
      })
    },
    //送审
    toSend: function () {
      this.exitDetailData.orderType = '11002'
      Bussiness.ApprovalSend(this.exitDetailData)
    },
    async revertApproval () {
      this.exitDetailData.orderType = '11002'
      await Bussiness.ApprovalRevert(this.exitDetailData)
      this.getRefundDetail()
    },
    //取消退票
    cancleRefundTicket (id) {
      this.$dialog.alert({
        title: this.$t('C474','提示'),
        message: '您确定要取消退票吗？'
      }).then(() => {
        // on close
        this.toCancleRefundAjax(id)
      })
    },
    toCancleRefundAjax (id) {
      this.$api['tkOrder/refundCancel']({
        refundOrderId: id
      }).then(() => {
        this.$toast('取消成功！')
        this.getRefundDetail()
      })
    },
    // 查看退票政策
    lookRefundDetail (info) {
      var obj={
        'airline': this.exitDetailData.airline,
        'cabin': info.cabin,
        'departDate': info.departDate,
        'salePrice': ''
      }
      if(this.exitDetailData.refundRangeList&&this.exitDetailData.refundRangeList.length==1){
        obj.salePrice=this.exitDetailData.tkOrderPsgBean.salePrice
      }
      this.$refs.mychild.getParams(obj)
      this.showRefundChange = true
    },
    //查看原订单
    lookToOldDetail (orderId) {
      this.$router.push({ path: '/tk/tkOrderDetaillc',query:{orderId:orderId}})
    },
    toggle(name){
      this.$refs[name].toggle()
    }
  }
}
</script>

<style lang="less" scoped>
    .tkRefundDetail{
      .fontTitle{
        display: flex;
        justify-content:space-between;
        align-items:center;
        .dowPdf{
          font-size: 16px;
        }
      }
    }
    .content{
        padding: 0 8px;
    }
    .m-b-5{
        margin-bottom: 5px;
    }
    .pad-8{
        padding: 8px;
    }
    .tkRefundDetailswrapper{
        height: calc(100vh - 94px);
        overflow: hidden;
    }
</style>
